import BeeSwitch from './switch.vue'

BeeSwitch.install = (Vue) => {
  Vue.component(BeeSwitch.name, BeeSwitch)
}

export default BeeSwitch



// WEBPACK FOOTER //
// ./src/components/switch/index.js